import { useQuery, useMemo, useAbValues } from 'sb-hooks'
import { useConnect } from 'sb-redux-hook'
import { useIntl } from 'sb-react-intl'
import { constants, array } from 'common/helpers'

import messages from './messages'
import productsQuery from './products.graphql'


type Season = 'winter' | 'spring' | 'summer' | 'fall'


const useData = () => {
  const intl = useIntl()

  const { gender } = useConnect({
    gender: 'models.me.gender',
  })

  const isSeasonProductsEnabled = useAbValues(constants.abTests.emptyQueueTrendingSeason) === 'b'

  const season = useMemo<Season>(() => {
    // from 0 to 11
    const month = (new Date()).getMonth()

    if (month >= 2 && month <= 4) {
      return 'spring'
    }

    if (month >= 5 && month <= 7) {
      return 'summer'
    }

    if (month >= 8 && month <= 10) {
      return 'fall'
    }

    return 'winter'
  }, [])

  const title = useMemo(() => {
    if (!isSeasonProductsEnabled) {
      return messages.title
    }

    const seasonIntl = intl.formatMessage(messages[season])

    return { ...messages.seasonsTitle, values: { season: seasonIntl } }
  }, [ intl, isSeasonProductsEnabled, season ])

  const queryOptions = useMemo(() => ({
    name: 'emptyQueueRecommendationsProducts',
    cache: true,
    variables: {
      gender,
      legacy: !isSeasonProductsEnabled,
    },
    modifyResult: (data) => data.products || data.recommendationsEmptyProduct,
  }), [ gender, isSeasonProductsEnabled ])

  const { data, isFetching } = useQuery<any[]>(productsQuery, queryOptions)

  const products = useMemo(() => {
    if (!data) {
      return []
    }

    return array.shuffle(data)
  }, [ data ])

  const [ metadata, snowplowMetadata ] = useMemo(() => {
    const recommenderName = isSeasonProductsEnabled ? 'filterSeasonal' : undefined

    return [
      {
        placement: 'empty queue click',
        recommenderName,
      },
      {
        placement: 'empty queue recommendations modal',
        recommenderName,
      },
    ]
  }, [ isSeasonProductsEnabled ])

  return {
    title,
    products,
    isFetching,
    metadata,
    snowplowMetadata,
  }
}


export default useData
